import React, { useEffect, useRef } from "react";
import "./UserRoleContextMenu.css";
import archiveIcon from "../../assets/archive.svg";
import ReactDOM from "react-dom";
import deleteIcon from "../../assets/delete.svg";
import { useSelector } from "react-redux";
import editIcon from "../../assets/edit.svg";
import { userSelector } from "../../store/selectors";
import { ReactComponent as DeleteIcon } from "../../assets/delete-color.svg";
import { ReactComponent as EditIcon } from "../../assets/edit-color.svg";
import { ReactComponent as ArchiveIcon } from "../../assets/archive-color.svg";

const UserRoleContextMenu = ({
  isOpen,
  onClose,
  onRemove = () => {},
  onEditUserRole = () => {},
  contextMenuPosition,
}) => {
  const menuRef = useRef(null);
  const user = useSelector(userSelector);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        event.target.className !== "comment-context-menu-item-text"
      ) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const menu = (
    <div
      className="comment-context-menu"
      ref={menuRef}
      style={{
        position: "absolute",
        top: contextMenuPosition.top,
        left: contextMenuPosition.left,
        zIndex: 2000,
        width: 140,
      }}
    >
      <div
        className="comment-context-menu-item"
        onClick={() => {
          onEditUserRole();
          onClose();
        }}
      >
        <span className="comment-context-menu-item-text">Настроить доступ</span>
      </div>
      <div
        className="comment-context-menu-item"
        onClick={() => {
          onRemove();
          onClose();
        }}
      >
        <span className="comment-context-menu-item-text">Удалить доступ</span>
      </div>
    </div>
  );

  return ReactDOM.createPortal(menu, document.body);
};

export default UserRoleContextMenu;
